// extracted by mini-css-extract-plugin
module.exports = {"effortlessly":"Effortlessly_effortlessly__V46mD"};